import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Input, Icon, Button, Select, Spin, Empty } from 'antd';
import PropTypes from 'prop-types';
import ImportPopup from '../../Components/Popup/ImportPopup';
import ConfirmActionPopup from '../../Components/Popup/ConfirmPopup';
import search from '../../Images/Icons/search.svg';
import TableView from '../../Components/Table';
import ModelActiveComponent from './Components/ModelActiveComponent';
import InferenceSettings from '../Inference/Component/InferenceSettings';
import ImportExportLoader from '../../Components/Loader/ImportExportLoader';
import {
  fetchModels,
  modelImport,
  modelDelete,
  modelArchive,
  inferenceStart,
  fetchUserDevices,
} from './ModelList.saga';
import { storeModelDetails } from '../Login/Login.reducer';
import 'antd/dist/antd.css';
import './ModelList.css';
import styles from './ModelList.module.css';

const { Search } = Input;
const { Option } = Select;

const modelColumns = {
  image: {
    title: 'IMAGE',
    key: 'fileContent',
    dataIndex: 'fileContent',
    width: '50px',
    order: 0,
  },
  name: {
    title: 'MODEL NAME',
    key: 'modelName',
    dataIndex: 'modelName',
    width: '150px',
    order: 0,
  },
  type: {
    title: 'MODEL LEARNING MODE',
    dataIndex: 'modelLearningMode',
    key: 'modelLearningMode',
    width: '130px',
    order: 2,
  },
  actions: {
    title: '',
    dataIndex: 'actions',
    key: 'actions',
    width: '50px',
    dropDownList: {
      edit: 'Edit',
      delete: 'Delete',
      clone: 'Clone',
      archive: 'Archive',
    },
    order: 10,
  },
  emptyCells: {
    title: '',
    dataIndex: 'emptyCells',
    key: 'emptyCells',
    width: '20px',
    order: 15,
  },
};

function ModelList({
  fetchModelsAction,
  modelImportAction,
  modelDeleteAction,
  modelArchiveAction,
  inferenceStartAction,
  storeModelDetailsAction,
  fetchUserDevicesAction,
  history,
  modelRepositories,
  userDetails,
  importLoader,
  showRedundantViews,
  devices,
}) {
  const [modelActiveRecord, setModelActiveRecord] = useState({});
  const [importPopup, setImportPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [inferencePopup, setInferencePopup] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [model, setModel] = useState({});
  const [fetching, setFetching] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [isBottom, setIsBottom] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [modelParams, setModelParams] = useState({
    offset: 0,
    size: 7,
    searchValue: '',
    sortBy: '',
    sortDirection: '',
  });
  const [devicesParams, setDevicesParams] = useState({
    offset: 0,
    size: 15,
    searchValue: '',
  });
  let permissions = {};
  const role = userDetails && userDetails.roleName;
  if (role) {
    permissions = {
      delete: true,
      showActions: true,
      archive: role !== 'Operator',
    };
  }

  useEffect(() => {
    fetchModelsAction({
      params: modelParams,
      callback: (activeRecord) => {
        setModelActiveRecord(activeRecord);
      },
    });
    // const { history, userDetails } = this.props;
    // if (userDetails && userDetails.roleName === "Operator") {
    //	 history.push("/workspace");
    // }
    // if (userDetails && userDetails.roleName && userDetails.roleName !== "Operator") {
    //	 this.props.fetchModels({
    //		 params: this.state.modelParams,
    //		 callback: (activeRecord) => {
    //			 this.setState({
    //				 modelActiveRecord: activeRecord
    //			 });
    //		 }
    //	 });
    // }
  }, [fetchModelsAction, modelParams]);

  // componentWillReceiveProps(nextProps) {
  //	 const { history, userDetails } = this.props;
  //	 if (JSON.stringify(userDetails) !== JSON.stringify(nextProps.userDetails) && nextProps.userDetails) {
  //		 if (nextProps && nextProps.userDetails && nextProps.userDetails.roleName === "Operator") {
  //			history.push("/workspace");
  //		 }
  //		 if (nextProps && nextProps.userDetails && nextProps.userDetails.roleName && nextProps.userDetails.roleName !== "Operator") {
  //			this.props.fetchModelRepositoryList({
  //				params: this.state.modelParams,
  //				callback: (activeRecord) => {
  //					this.setState({
  //						modelActiveRecord: activeRecord
  //					 });
  //				 }
  //			 });
  //		 }
  //	 }
  // }

  useEffect(() => {
    fetchUserDevicesAction({
      params: devicesParams,
      callback: (remainingDevices) => {
        setFetching(false);
        setIsBottom(remainingDevices < devicesParams.size);
      },
    });
  }, [devicesParams]);

  const closeImportPopup = () => {
    setImportPopup(false);
  };

  const onModelImport = (currentModel) => {
    modelImportAction({
      currentModel,
      callback: () => {
        closeImportPopup();
      },
    });
  };

  const openImportPopup = () => {
    setImportPopup(true);
  };

  const deleteModelConfirm = (currentModel) => {
    setDeletePopup(true);
    setModel(currentModel);
  };

  const deleteModelCancel = () => {
    setDeletePopup(false);
    setModel({});
  };

  const deleteModel = () => {
    modelDeleteAction({
      payload: [model.modelId],
      callback: () => {
        // const models = this.props.modelList && this.props.modelList.models;
        // if (models.length > 0)
        // 	this.props.fetchModelList({
        // 		params: this.state.fetchModelParams,
        // 		workspaceId: this.props.match.params.workspaceId
        // 	});
        // else {
        // 	this.setState({
        // 		fetchModelParams: {
        // 			...this.state.fetchModelParams,
        // 			offset: this.state.fetchModelParams.offset === 0 ? 0 : this.state.fetchModelParams.offset - 1,
        // 		}
        // 	}, () => {
        // 		this.props.fetchModelList({
        // 			params: this.state.fetchModelParams,
        // 			workspaceId: this.props.match.params.workspaceId
        // 		});
        // 	})
        // }
      },
    });
    deleteModelCancel();
  };

  const archiveModel = (currentModel) => {
    modelArchiveAction(currentModel.modelId);
  };

  const inferenceModelCancel = () => {
    setInferencePopup(false);
    setPopupLoading(false);
  };

  const startInference = () => {
    // if (selectedDevices.length) {
    setLoading(true);
    setConfirmDisabled(true);
    setPopupLoading(true);
    inferenceStartAction({
      data: {
        modelId: modelActiveRecord.modelId,
        inputClientIds: selectedDevices,
      },
      callback: () => {
        inferenceModelCancel();
        setLoading(false);
      },
    });
    // }
  };

  const goToInference = () => {
    history.push('/model-list/modelId/inference/inferenceId');
  };

  const viewInferences = () => {
    storeModelDetailsAction(modelActiveRecord);
    history.push(`/model-list/${modelActiveRecord.modelId}/runtime-history`);
  };

  const handlePageChange = (offset, sortBy, sortDirection) => {
    setModelParams((prevParams) => ({
      ...prevParams,
      offset,
      sortBy,
      sortDirection,
    }));
  };

  const handleSearch = (event) => {
    const {
      target: { value },
    } = event;
    setModelParams((prevParams) => ({
      ...prevParams,
      searchValue: value,
    }));
  };

  const handleRecordClick = (record) => {
    setModelActiveRecord(record);
  };

  const handleDeviceSearch = (value, mode) => {
    setDevicesParams((prevParams) => ({
      ...prevParams,
      offset: 0,
      searchValue: mode ? value : '',
    }));
    setFetching(true);
  };

  const handleDeviceSelect = (selectedItems) => {
    setConfirmDisabled(Boolean(!selectedItems.length));
    setSelectedDevices(selectedItems);
  };

  const handleDevicesScroll = (event) => {
    const { target } = event;
    if (target.scrollHeight - target.scrollTop <= target.clientHeight + 1) {
      setIsBottom(true);
      if (!isBottom) {
        setDevicesParams((prevParams) => ({
          ...prevParams,
          offset: prevParams.offset + 1,
        }));
      }
    }
  };
  const clientHeight =
    document.getElementById('tableContainer') &&
    document.getElementById('tableContainer').clientHeight;
  return (
    <>
      <div className={styles.content}>
        <div className={styles.contentWrapper}>
          <div className={styles.tableWrapper} id="tableContainer">
            <div className={styles.optionsContainer}>
              <Search
                prefix={
                  <Icon
                    onClick={() => {
                      if (document.getElementById('searchInputId')) {
                        document.getElementById('searchInputId').focus();
                      }
                    }}
                    component={() => (
                      <img
                        alt="Search Icon"
                        src={search}
                        style={{
                          height: '20px',
                        }}
                      />
                    )}
                  />
                }
                placeholder="Search models"
                id="searchInputId"
                onChange={handleSearch}
                className={styles.searchInputBox}
              />
              <Button
                icon="download"
                className="workspaceButton"
                onClick={openImportPopup}
              >
                {importLoader ? (
                  <ImportExportLoader text="Importing" />
                ) : (
                  'Import'
                )}
              </Button>
            </div>
            <div className={styles.tableContainer}>
              <TableView
                clientHeight={clientHeight - 210}
                columnNames={modelColumns}
                totalRecords={
                  modelRepositories && modelRepositories.totalRecords
                }
                data={modelRepositories && modelRepositories.models}
                fetchRecords={handlePageChange}
                activeRecord={modelActiveRecord}
                onRecordClick={handleRecordClick}
                permissions={permissions}
                tableType="model"
                deleteRecord={deleteModelConfirm}
                archiveRecord={archiveModel}
                showRedundantViews={showRedundantViews}
              />
            </div>
          </div>
          <div
            style={{
              marginLeft:
                modelRepositories &&
                modelRepositories.models &&
                modelRepositories.models.length
                  ? '-10px'
                  : '10px',
            }}
            className={styles.activeItemWrapper}
          >
            {modelActiveRecord && (
              <ModelActiveComponent
                history={history}
                modelActiveRecord={modelActiveRecord}
                startInference={() => {
                  startInference();
                  // setInferencePopup(true);
                }}
                inference={goToInference}
                inferenceList={viewInferences}
                archive={false}
              />
            )}
          </div>
        </div>
      </div>
      {importPopup && (
        <ImportPopup
          visible={importPopup}
          closeImport={closeImportPopup}
          fileImport={onModelImport}
          title="Import Model"
        />
      )}
      {deletePopup && (
        <ConfirmActionPopup
          title="Delete Model"
          activeRecord={model}
          visible={deletePopup}
          actionType="delete"
          content="model"
          onCancel={deleteModelCancel}
          onConfirm={deleteModel}
        />
      )}
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.2)',
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {false && (
        <InferenceSettings
          modal
          modalClose={() => setInferencePopup(false)}
          onSubmit={() =>
            history.push('/model-list/modelId/inference/inferenceId')
          }
        />
      )}
      {inferencePopup && (
        <ConfirmActionPopup
          title="Start Inference"
          activeRecord={modelActiveRecord}
          visible={inferencePopup}
          actionType="start inference for"
          content="model"
          onCancel={inferenceModelCancel}
          onConfirm={startInference}
          loading={popupLoading}
          disabled={confirmDisabled}
          loadingText="Starting Inference"
        >
          <Select
            mode="multiple"
            placeholder="Choose Devices from List"
            className={`fieldSelect ${styles.deviceSelection}`}
            dropdownClassName="fieldSelectDropdownClassName"
            value={selectedDevices}
            onChange={handleDeviceSelect}
            notFoundContent={fetching ? <Spin size="small" /> : <Empty />}
            onSearch={(val) => handleDeviceSearch(val, true)}
            onBlur={(val) => handleDeviceSearch(val, false)}
            filterOption={false}
            onPopupScroll={handleDevicesScroll}
            allowClear
          >
            {!fetching &&
              devices
                .filter((device) => device.clientStatus === 'Available')
                .map((device) => {
                  return (
                    <Option key={device.clientUuid}>{device.clientName}</Option>
                  );
                })}
          </Select>
        </ConfirmActionPopup>
      )}
    </>
  );
}

ModelList.defaultProps = {
  fetchModelsAction: (f) => f,
  modelImportAction: (f) => f,
  modelDeleteAction: (f) => f,
  modelArchiveAction: (f) => f,
  inferenceStartAction: (f) => f,
  storeModelDetailsAction: (f) => f,
  fetchUserDevicesAction: (f) => f,
  history: {
    push: (f) => f,
  },
  modelRepositories: {},
  userDetails: {},
  importLoader: false,
  showRedundantViews: false,
  devices: [],
};

ModelList.propTypes = {
  fetchModelsAction: PropTypes.func,
  modelImportAction: PropTypes.func,
  modelDeleteAction: PropTypes.func,
  modelArchiveAction: PropTypes.func,
  inferenceStartAction: PropTypes.func,
  storeModelDetailsAction: PropTypes.func,
  fetchUserDevicesAction: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  modelRepositories: PropTypes.instanceOf(Object),
  userDetails: PropTypes.instanceOf(Object),
  importLoader: PropTypes.bool,
  showRedundantViews: PropTypes.bool,
  devices: PropTypes.instanceOf(Array),
};

export default withRouter(
  connect(
    (state) => ({
      modelRepositories:
        state.modelListReducer && state.modelListReducer.entity,
      userDetails: state.loginReducer.userDetails,
      importLoader: state.commonReducer.importLoader,
      showRedundantViews: state.commonReducer.showRedundantViews,
      devices: state.modelListReducer && state.modelListReducer.devices,
    }),
    {
      fetchModelsAction: fetchModels,
      modelImportAction: modelImport,
      modelDeleteAction: modelDelete,
      modelArchiveAction: modelArchive,
      storeModelDetailsAction: storeModelDetails,
      inferenceStartAction: inferenceStart,
      fetchUserDevicesAction: fetchUserDevices,
    }
  )(ModelList)
);
